import React from "react";
import { Button } from 'react-bulma-components';
import {Link} from "react-router-dom";


const navLayoutStyle = {
    backgroundColor: 'white',
    minHeight: '100px',
    height: '10vh',
    width: '100vw',
    top: '0px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
};

const titleStyle = {
    color: 'red',
    padding: '0px 10px 0px 10px',
    margin: '-37px 0px 10px 0px',
    float: 'right',
    fontSize: '7em',
};

const subtitleStyle = {
    color: '#65ad2e',
    padding: '0px 10px 0px 0px',
    margin: '10px 0px 10px 0px',
    float: 'right',
    fontSize: '3em',
    lineHeight: '85%',
};

const logos = {
    display: 'flex',
    flexDirection: 'row',
    float: 'left',
}

const title = {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'middle',
    marginLeft: 'auto',
    marginRight: 'auto',
}

const buttonsStyle = {
    float: 'right',
    margin: '20px 20px 20px 0px',
    height: '72px',
}

let regLogInButtonsStyle = {
    float: 'right',
    margin: '20px 20px 20px 0px',
    height: '72px',
}

let logOutButtonsStyle = {
    float: 'right',
    margin: '20px 20px 20px 0px',
    height: '72px',
}


function HospitalsHeader() {

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    const logOut = () => {

        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
        console.log("Logging out")

        console.log()
        window.location.assign("http://localhost:3000/")
    }

    let user = readCookie("Username")
    console.log(user)

    if (user !== null) {
        console.log("Header - Logged in")
        regLogInButtonsStyle = {
            display: 'none'
        }

    } else {
        logOutButtonsStyle = {
            display: 'none'
        }
    }

    return (
        <div style={navLayoutStyle}>
            <div style={logos}>
                <img src="assets/ictdivlogo.png" style={{padding: "10px"}}></img>
                <img src="assets/braculogo.png" style={{padding: "5px"}}></img>
            </div>
            <div style={title}>
                <Link to="/">
                    <h1 style={subtitleStyle}><b>Hospitals<br/>Portal</b></h1>
                    <h1 style={titleStyle}><b>EAS</b></h1>
                </Link>
            </div>
            <Button color="info" size="medium" style={logOutButtonsStyle} onClick={logOut}>
                <span>Sign Out</span><br/>
            </Button>
            <Link to="/login">
                <Button color="info" size="medium" style={regLogInButtonsStyle}>
                    <span>Sign In</span><br/>
                </Button>
            </Link>
            <Link to="/register">
                <Button color="info" size="medium" style={regLogInButtonsStyle}>
                    <span>Register</span><br/>
                </Button>
            </Link>
        </div>
    );

}

export default HospitalsHeader;
